import { Button, CircularProgress, styled } from '@mui/material';
import { calculateMinWidthBySize, calculatePaddingBySize } from 'src/components/button/size';
import { CustomButtonProps } from 'src/components/button/type';

// キャンセルボタンなどに使う。メインとなる機能
// sizeを指定しない場合はSサイズになる。
// small: 2~4文字のテキストに利用
// medium: 5~8文字または小文字含めて6~9文字のテキストに利用
export const SubButton = styled(({ loading, ...props }: CustomButtonProps) => (
  <Button {...props}>
    {loading ? <CircularProgress color="inherit" size={24} /> : props.children}
  </Button>
))(({ theme, size }) => ({
  width: 'fit-content',
  minWidth: calculateMinWidthBySize(size),
  borderRadius: '4px',
  border: `1px solid ${theme.palette.grey[500]}`,
  color: theme.palette.grey[500],
  padding: calculatePaddingBySize(size),
  fontSize: '14px',
  '@media screen and (max-width:1440px)': {
    fontSize: '12px',
    padding: '6px',
  },
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
  '&:focus': {
    borderWidth: '2px',
  },
  '&:disabled': {
    color: theme.palette.grey[500],
    opacity: 0.5,
  },
}));
